// extracted by mini-css-extract-plugin
export default {"appointment_booking":"AppointmentBooking_appointment_booking__vyY6r"};